import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FREESTAR_ENABLED } from 'src/common/constants/experiments/ads';
import useExperiment from 'src/common/hooks/useExperiment';
import { selectBreakpoint, selectRouteProps } from 'src/common/selectors/app';
import cssVariables from 'src/common/styles/variables';
import { getDisplayAdAttributes, gptSlotNames } from 'src/common/utils/ads/config';
import { useDetermineAdEligibility } from 'src/common/utils/ads/determineAdEligibility';
import { isDiscordMode } from 'src/common/utils/discord';
import DisplayAd from '../ads/DisplayAd';
import showProfileAdInContentArea from '../profile/utils/showProfileAdInContentArea';
import UpsellRightSidebar from '../subscription/UpsellRightSidebar';

export function useCanShowProfilePageAds() {
  const breakpoint = useSelector(selectBreakpoint);
  const routeProps = useSelector(selectRouteProps);
  const { guideId } = routeProps?.guideContext || {};
  const canShowAds = useDetermineAdEligibility(guideId);
  const [shouldShowProfileAdInContentArea, setShouldShowProfileAdInContentArea] = useState(false);

  useEffect(() => {
    if (!isDiscordMode()) {
      /**
       * Setting this flag in state because the server would otherwise set it to true by default, potentially causing
       * UpsellRightSidebar to report a view once in Profile.js again in RightSide.js, once the client sets the true value
       * of app.breakpoint in the store.
       */
      setShouldShowProfileAdInContentArea(
        Boolean(showProfileAdInContentArea(breakpoint) && canShowAds),
      );
    }
  }, [breakpoint, canShowAds]);

  return shouldShowProfileAdInContentArea;
}

export function ProfilePageAds() {
  const routeProps = useSelector(selectRouteProps);
  const { guideId } = routeProps?.guideContext || {};
  const isFreestarEnabled = useExperiment(FREESTAR_ENABLED);

  return (
    <>
      <DisplayAd
        style={{
          float: 'right',
          paddingLeft: cssVariables['--extra-margin'],
          paddingBottom: '25px',
        }}
        guideId={guideId}
        matchUrl={routeProps.matchUrl}
        isProfile
        {...getDisplayAdAttributes(gptSlotNames.profile_side, isFreestarEnabled)}
      />
      {/* important: the key prop allows the component to remount and log upsell activity on pathname change */}
      <UpsellRightSidebar key={location.pathname} guideId={guideId} isProfile />
    </>
  );
}
